import * as yup from 'yup';

import {
  emailValidationSchema,
  phoneValidationSchema,
} from 'common/validation';

const addressValidationSchema = yup.object({
  street1: yup.string().min(1).required(),
  street2: yup.string().optional().nullable(),
  city: yup.string().min(1).required(),
  state: yup.object({
    id: yup.string().required(),
  }),
  postalCode: yup.string().min(1).required(),
});

const contactValidationSchema = yup.object({
  firstName: yup.string().min(1).required(),
  lastName: yup.string().min(1).required(),
  jobTitle: yup.string().min(1).required(),
  email: emailValidationSchema,
  mobilePhone: yup.object({
    number: phoneValidationSchema,
  }),
});

const dayValidationSchema = yup
  .object({
    openTime: yup.string().required(),
    closeTime: yup
      .string()
      .test(
        'open_close_validation',
        'Close time should be after Open time',
        (closeTime, schema) =>
          schema.parent.openTime.localeCompare(closeTime) < 0
      )
      .required(),
  })
  .nullable()
  .notRequired()
  .default(undefined);

const departmentValidationSchema = yup.object({
  phone: phoneValidationSchema,
  email: emailValidationSchema,
  schedule: yup
    .object({
      monday: dayValidationSchema,
      tuesday: dayValidationSchema,
      wednesday: dayValidationSchema,
      thursday: dayValidationSchema,
      friday: dayValidationSchema,
      saturday: dayValidationSchema,
      sunday: dayValidationSchema,
    })
    .nullable(),
});

const validationSchema = yup.object({
  name: yup.string().min(1).required(),
  parent: yup
    .object({
      id: yup.string().nullable(),
    })
    .nullable(),
  websiteUrl: yup.string().url('Enter a valid URL').required(),
  timezone: yup.object({
    label: yup.string().required(),
    timezone: yup.string().required(),
  }),
  mainDepartment: departmentValidationSchema,
  billingAddress: addressValidationSchema,
  billingContact: contactValidationSchema,
  mailingAddress: addressValidationSchema,
  mailingContact: contactValidationSchema,
  salesDepartment: departmentValidationSchema,
  partsDepartment: departmentValidationSchema,
  serviceDepartment: departmentValidationSchema,
});

export default validationSchema;
